"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCollaboration = void 0;
const index_1 = require("../../Model/index");
const TypeFactory_1 = require("../TypeFactory");
const MessageFlowParser_1 = require("./MessageFlowParser");
function parseCollaboration(parsedObjectModel) {
    const collaborationRaw = parsedObjectModel[index_1.BpmnTags.CommonElement.Collaboration];
    const collaboration = (0, TypeFactory_1.createObjectWithCommonProperties)(collaborationRaw, index_1.Model.Collaboration);
    const collaborationId = collaboration.id;
    try {
        collaboration.name = collaborationRaw.name;
        collaboration.participants = getCollaborationParticipants(collaborationRaw);
        collaboration.messageFlows = (0, MessageFlowParser_1.parseMessageFlows)(collaborationRaw);
        return collaboration;
    }
    catch (error) {
        error.additionalInformation = {
            ...error.additionalInformation,
            collaborationId: collaborationId,
        };
        throw error;
    }
}
exports.parseCollaboration = parseCollaboration;
function getCollaborationParticipants(collaborationData) {
    const participantsRaw = (0, TypeFactory_1.getModelPropertyAsArray)(collaborationData, index_1.BpmnTags.CommonElement.Participant);
    const participants = [];
    for (const participantRaw of participantsRaw) {
        const participant = (0, TypeFactory_1.createObjectWithCommonProperties)(participantRaw, index_1.Model.Participant);
        participant.name = participantRaw.name;
        participant.processReference = participantRaw.processRef;
        participants.push(participant);
    }
    return participants;
}
//# sourceMappingURL=CollaborationParser.js.map